import { get, post } from "../../axios-interceptor-setup/apiService";

const BASE_URL = "/smart_city_tcu";

export const getTCUKpis = (body) => {
    return post(`${BASE_URL}/tcuCount`, {...body});
}

export const getLostTCUData = (body) => {
    return post(`${BASE_URL}/tcuCountByCity`, {...body}); //
}

export const getDepotWiseDataByCity = (body) => {
    return post(`${BASE_URL}/tcuCountByCityDepo`, {...body});
}

export const getCityDepotContract = (body) => {
    return post(`${BASE_URL}/locationFilter `, {...body});
}

export const getDepotByCity = (body) => {
    return post(`${BASE_URL}/depotFilter`, {...body});
}

export const getVehiclesByDepot = (body) => {
    return post(`${BASE_URL}/tableVehicleAgeing`, {...body});
}

export const downloadTCUKpis = (api,body) => {
    return post(`${BASE_URL}/${api}`, {...body}, {
    responseType: "blob",
  });
}

export const downloadTCUVehicleData = (body) => {
    return post(`${BASE_URL}/downloadVehicleAgeing`, {...body}, {
    responseType: "blob",
  });
}

export const getLastRefreshDate = () => {
    return post(`${BASE_URL}/lastRefreshDate
 `, {});
}

export const loggingApiTCU = (body) => {
    return post(`/auth/logging`, {page_name: "TCU_BUS"});
}
